<template>
    <div class="recinto-anexo-wrapper tw:relative">
        <div
            v-if="loading && !ocultarLoader"
            class="recinto-anexo-loader tw:absolute tw:top-0 tw:right-0 tw:bottom-0 tw:left-0 tw:z-10 tw:flex tw:items-center tw:justify-center tw:bg-white"
        >
            <ContentOrLoading />
        </div>
        <div class="row recinto-anexo__mapa" :class="{ 'tw:invisible': loading }">
            <div class="col-12 text-center p-3 lightgray-content">
                <div v-if="tipoSvgSeleccionado === 1" ref="contenedorMapa">
                    <SvgPanZoom
                        v-if="svg_loaded && panzoomUtilizable"
                        class="svgpanzoom-container"
                        :zoomEnabled="true"
                        :controlIconsEnabled="false"
                        :fit="true"
                        :center="true"
                        :mouseWheelZoomEnabled="habilitarZoomRueda"
                        :zoomScaleSensitivity="2"
                        :dblClickZoomEnabled="false"
                        :preventMouseEventsDefault="false"
                        @svgpanzoom="registerSvgPanZoom"
                        @wheel.native="prevenirScrollRueda"
                    >
                        <svg v-html="svg_loaded"/>
                    </SvgPanZoom>
                    <div class="text-center" v-if="load_panzoom">
                        <button @click="zoomIn()" class="button panzoom-button">+</button>
                        <button @click="zoomOut()" class="button panzoom-button">-</button>
                    </div>
                </div>
                <LeafletComponent
                    v-else-if="svgRendered"
                    :plazasSeleccionadas="plazasSeleccionadas"
                    :continuarConCompra="continuarConCompra"
                    :svgRendered="svgRendered"
                    :originalColor="originalColor"
                    :disabled="bloquearPasoDos"
                    @isPanning="(e) => isPanning = e"
                />
                <!-- Solo los planos de regiones traen el ancla `popover-<id>` de cada plaza; el SVG
                     de butacas no la tiene y ahí el popover se pinta sobre la propia butaca. Se crea
                     únicamente para las plazas con ancla en el SVG: sin ancla, BootstrapVue avisa y
                     el popover no llega a abrirse nunca. -->
                <template v-if="!loading">
                    <b-popover
                        v-for="plaza in plazasConPopover"
                        :key="plaza.id"
                        :target="'popover-' + plaza.id" 
                        triggers="hover focus"
                    >
                        <template slot="title">{{ plaza.name }}</template>

                        <div v-if="plaza.disponible && plaza.precios.length > 0">{{ $t('general.desde') + ': ' + getPrecioPlaza(plaza) | formatear_precio }} </div>
                        <div v-else-if="! plaza.disponible && plaza.precios.length > 0">{{ $t('partido.ocupado') }}</div>
                        <div v-else>{{ $t('mapa.no_disponible') }}</div>
                    </b-popover>
                </template>
            </div>
            <template v-if="taquilla">
                <div class="col-12 mt-4">
                    <LeyendaColorEventos />
                </div>
                <div class="col-12 d-md-flex align-items-center mt-4">
                    <div v-if="!ocultarControlesSeleccion">
                        <FormInput label="Número de butacas" type="number" max="100" name="n_butacas" v-model="n_butacas" />
                    </div>
                    <div :class="{ 'ml-3': !ocultarControlesSeleccion }">
                        <Button v-if="!ocultarControlesSeleccion" class="m-1" @click="selectButacas" :disabled="bloquearPasoDos || n_butacas === 0 || n_butacas > 30">Seleccionar</Button>
                        <Button v-if="!ocultarControlesSeleccion" class="m-1" @click="selectAllButacas" :disabled="bloquearPasoDos">Seleccionar todas</Button>
                        <Button v-if="!ocultarBorrarSeleccion" class="m-1" @click="clearButacas" :disabled="disabled || bloquearPasoDos">Borrar selección</Button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import SvgPanZoom from 'vue-svg-pan-zoom';
    import LeafletComponent from '@/components/svg/components/LeafletComponent.vue';
    import { Popover } from 'bootstrap';
    import LeyendaColorEventos from '@/views/backend/events/sesiones/bloquear-asientos/LeyendaColorEventos.vue';

    export default {
        props: {
            region_id: null,
            plazas: null,
            continuarConCompra: null,
            tipo_svg: null,
            habilitarZoomRueda: {
                type: Boolean,
                default: false
            },
            tipo_svg_taquilla: {
                type: [Number, String],
                default: null
            },
            plazasSeleccionadas: null,
            disabled: null,
            plazaParaBorrar: null,
            bloquearPasoDos: null,
            recinto_id: null,
            // Solo el flujo de taquilla lo informa; con el valor por defecto (`null`)
            // el componente no repinta nada y conserva el comportamiento de online.
            plazasSeleccionadasIds: {
                type: Array,
                default: null
            },
            ocultarBorrarSeleccion: {
                type: Boolean,
                default: false
            },
            ocultarControlesSeleccion: {
                type: Boolean,
                default: false
            },
            // Tope de butacas que el selector puede añadir. Solo lo informa el
            // día del abonado online: sin él (`null`) el mapa no limita por su
            // cuenta y se queda como siempre.
            maxSeleccionables: {
                type: [Number, String],
                default: null
            },
            // Solo lo informa quien ya pinta su propio loader mientras se
            // resuelven las butacas y el SVG (`SelectorAsientoComponent`). Con
            // `false` el mapa sigue mostrando el suyo, como toda la vida.
            ocultarLoader: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                svg_loaded : '',
                loading: true,
                can_click: true,
                svgpanzoom: null,
                svg: null,
                svgRendered: null,
                originalColor: '#0CBA31',
                noDisponibleColor: 'gray',
                seleccionadaColor: '#8CA9D9',
                bloqueadaEventosColor: '#BF95C4', 
                enSesionEventosColor: 'yellow', 
                vendidaEventosColor: 'red',
                bloqueadaAbonosColor: 'purple', 
                enSesionAbonosColor: 'orange', 
                vendidaAbonosColor: 'black',
                validadaColor: '#01018A',
                isPanning: null,
                n_butacas: 0,
                // El panzoom solo se monta cuando el contenedor del mapa tiene layout y
                // tamaño reales: sin ellos svg-pan-zoom calcula una matriz no finita.
                panzoomUtilizable: false,
                observadorDimensionesMapa: null,
                // Plazas cuyo SVG trae el ancla `popover-<id>`, que es lo que necesita el
                // popover de regiones. Se recalcula al pintar el SVG y cuando llegan plazas.
                plazasConPopover: []
            }            
        },
        created() {
            this.getSvg();
        },
        mounted() {
            this.medirContenedorMapa();
            this.observarDimensionesMapa();
        },
        beforeDestroy() {
            this.dejarDeObservarDimensionesMapa();
        },
        watch: {
            svg_loaded() {
                // El SVG puede llegar con el paso oculto: se vuelve a medir antes de
                // decidir si se monta el panzoom y se deja observado el contenedor por si
                // el mapa se muestra más tarde.
                this.$nextTick(() => {
                    this.observarDimensionesMapa();
                    this.medirContenedorMapa();
                });
            },
            plazas: {
                handler() {
                    this.actualizarPlazasConPopover();
                },
                deep: true
            },
            plazasSeleccionadasIds: {
                handler() {
                    this.sincronizarMarcasSeleccionadas();
                },
                deep: true
            },
            plazaParaBorrar(newPlaza) {
                if (newPlaza) {
                    this.clickRegion(newPlaza.id);
                    const butaca = document.querySelector(`[id^="butaca-${newPlaza.svg_id}"]`) || document.querySelector(`[id^="butaca-${newPlaza.svg_id}-"]`) ;
                    if (butaca) {
                        butaca.setAttribute('fill', this.originalColor);
                        butaca.setAttribute('seleccionado', 'false');
                    }
                    this.$emit('setPlazaBorrar', newPlaza)
                }
            }
        },
        computed: {
            tieneTipoSvgTaquilla() {
                const tipoSvgTaquilla = Number(this.tipo_svg_taquilla);

                return tipoSvgTaquilla === 1 || tipoSvgTaquilla === 2;
            },
            tipoSvgDiscrepante() {
                return this.tieneTipoSvgTaquilla && Number(this.tipo_svg) !== Number(this.tipo_svg_taquilla);
            },
            tipoSvgSeleccionado() {
                return this.tieneTipoSvgTaquilla ? Number(this.tipo_svg_taquilla) : this.tipo_svg;
            },
            load_panzoom() {
                let load_panzoom = true

                let userAgent = navigator.userAgent || navigator.vendor || window.opera;

                if(/windows phone/i.test(userAgent)) {
                    load_panzoom = false;
                }
            
                if(/android/i.test(userAgent)) {
                    load_panzoom = false;
                }

                if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            taquilla() {
                var path = this.$router.currentRoute.fullPath;

                return path.includes('admin');
            }
        },
        methods: {
            registerSvgPanZoom(svgpanzoom) {
                this.svgpanzoom = svgpanzoom;

                // Con el mapa oculto, `loadSVG` registró la superficie cuando su SVG aún
                // no existía. Si el panzoom se monta ya visible, se registra aquí para que
                // el mapa quede utilizable (clics, marcas y popovers).
                if (this.loading || !this.$refs.contenedorMapa) {
                    return;
                }

                this.registrarSuperficieDelMapa(this.$refs.contenedorMapa);
            },
            /**
             * `SvgPanZoom` inicializa svg-pan-zoom en su propio `mounted`, y svg-pan-zoom
             * calcula la matriz inicial con el tamaño del SVG (`clientWidth`,
             * `getBoundingClientRect`) y con el `getBBox()` de su viewport. Con el paso 2
             * oculto (`v-show` en `#paso-2-contenido`) el mapa no tiene layout: el ancho es
             * 0 y el bbox también, la escala sale `0/0 = NaN` y `SVGMatrix.a` lanza
             * «The provided double value is non-finite». Por eso el panzoom solo se monta
             * cuando el contenedor tiene layout y tamaño reales.
             */
            medirContenedorMapa() {
                const contenedor = this.$refs.contenedorMapa;

                // Ya inicializado (o aún sin contenedor): no hay nada que decidir.
                if (!contenedor || this.svgpanzoom) {
                    return;
                }

                this.panzoomUtilizable = this.mapaTieneLayout(contenedor) && this.mapaTieneDimensiones(contenedor);
            },
            /**
             * Un `v-show` del paso deja `display: none` en un ancestro y, con él, el mapa
             * sin layout. `visibility: hidden` (con la que el mapa se oculta mientras
             * carga su propio loader) conserva el layout y no impide inicializar.
             */
            mapaTieneLayout(elemento) {
                let actual = elemento;

                while (actual) {
                    if (window.getComputedStyle(actual).display === 'none') {
                        return false;
                    }
                    actual = actual.parentElement;
                }

                return true;
            },
            mapaTieneDimensiones(contenedor) {
                const rect = contenedor.getBoundingClientRect();

                if (contenedor.clientWidth > 0 || contenedor.clientHeight > 0 || rect.width > 0 || rect.height > 0) {
                    return true;
                }

                // Sin motor de layout (jsdom) todas las medidas valen 0 y no se puede
                // distinguir «oculto» de «visible»: se conserva el comportamiento previo.
                // El navegador, que sí mide, siempre pasa por la comprobación real.
                return document.documentElement.clientWidth === 0 && document.documentElement.clientHeight === 0;
            },
            /**
             * Cuando el paso 2 vuelve a mostrarse el contenedor recupera su tamaño: el
             * `ResizeObserver` avisa de ese cambio. Sin él (navegadores antiguos) se
             * reintenta al redimensionar la ventana.
             */
            observarDimensionesMapa() {
                const contenedor = this.$refs.contenedorMapa;

                if (!contenedor || this.svgpanzoom) {
                    return;
                }

                this.dejarDeObservarDimensionesMapa();

                if (typeof window.ResizeObserver === 'undefined') {
                    window.addEventListener('resize', this.medirContenedorMapa);
                    return;
                }

                this.observadorDimensionesMapa = new window.ResizeObserver(() => this.medirContenedorMapa());
                this.observadorDimensionesMapa.observe(contenedor);
            },
            dejarDeObservarDimensionesMapa() {
                window.removeEventListener('resize', this.medirContenedorMapa);

                if (this.observadorDimensionesMapa) {
                    this.observadorDimensionesMapa.disconnect();
                    this.observadorDimensionesMapa = null;
                }
            },
            prevenirScrollRueda(event) {
                if (this.habilitarZoomRueda) {
                    event.preventDefault();
                }
            },
            zoomIn : function() {
                this.svgpanzoom.zoomIn();
            },
            zoomOut : function() {
                this.svgpanzoom.zoomOut();
            },
            getPrecioPlaza({ precios }) {
                if (precios.length > 0) {
                    let precioMasBajo = precios.reduce((menorPrecio, precio) => {
                        return Math.min(menorPrecio, precio.precio);
                    }, Number.POSITIVE_INFINITY)                
                
                    return Math.ceil(precioMasBajo * 100) / 100;
                }

                return 0;
            },
            getSvg() {
                this.loading = true;

                const usaRutaNeutral = this.recinto_id !== undefined && this.recinto_id !== null;
                const params = usaRutaNeutral
                    ? {
                        filters: {},
                        recinto_id: this.recinto_id,
                        region_id: this.region_id
                    }
                    : {
                        filters: {},
                        event_id: this.$route.params.event_id ?? this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id,
                        region_id: this.region_id
                    };
                const rutaSvg = usaRutaNeutral ? 'recinto.zona-svg' : 'front.zonas.recintos-anexos.svg';

                this.$store.dispatch(this.config.getVuexAlias(rutaSvg), params)
                    .then(({ data: { svg } }) => {
                        if (this.tipoSvgSeleccionado === 1) {
                            this.loadSVG(svg);
                        } else if (this.tipoSvgSeleccionado === 2) {
                            this.renderLeafletSvg(svg);
                        } else {
                            this.finalizarCargaSvg();
                        }
                    }).catch(error => {
                        console.log(error);
                        console.warn('Error al recuperar el SVG del recinto anexo');
                        // Si el SVG falla también hay que avisar, o el loader de fuera se
                        // quedaría girando indefinidamente.
                        this.finalizarCargaSvg();
                    })
            },
            finalizarCargaSvg() {
                this.loading = false;
                // El contenedor de fuera muestra un único loader mientras se
                // recuperan las butacas y este SVG: avisamos de que ya está pintado.
                this.$emit('cargado');
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                // El SVG ya está en el DOM tras el repintado: refleja la selección que
                // venga marcada (por ejemplo, la plaza del abonado).
                this.$nextTick(() => {
                    this.sincronizarMarcasSeleccionadas();
                });

                setTimeout(() => {
                    // Alinear con el retardo que ya usa el SVG clásico para registrar
                    // superficies una vez que el markup está disponible en el DOM.
                    this.registrarSuperficieDelMapa();
                    this.finalizarCargaSvg();
                }, 500);                
            },
            /**
             * Registra la superficie de clic del SVG que ya está pintado: clases de
             * disponibilidad, listeners de cada plaza, marcas de selección y popovers.
             *
             * `raiz` es `document` en la carga normal, como siempre; al inicializar el
             * panzoom con el mapa ya visible se limita a su propio contenedor.
             */
            registrarSuperficieDelMapa(raiz = document) {
                if (this.tipoSvgDiscrepante) {
                    this.registrarSuperficieAsientos();
                }

                let plazas = raiz.getElementsByClassName("recinto-zona");

                for(let i in plazas) {
                    if(plazas[i].dataset !== undefined) {
                        let plaza_id = plazas[i].dataset.region;

                        for(let j in this.plazas) {
                            if(this.plazas[j].id == plaza_id && this.plazas[j].precios.length == 0) {
                                plazas[i].classList.add("no-disponible");
                            }

                            if (this.plazas[j].id == plaza_id && !this.plazas[j].disponible) {
                                plazas[i].classList.add("plaza_ocupada");                                
                            }

                            if (this.plazas[j].id == plaza_id && this.plazas[j].disponible && this.plazas[j].precios.length > 0) {
                                plazas[i].classList.add("plaza_disponible");                                
                            }
                        }

                        plazas[i].addEventListener('click', () => {
                            this.clickRegion(plazas[i].dataset.region);
                        }, false);
                    }                                                                                            
                }

                this.actualizarPlazasConPopover();
                this.sincronizarMarcasSeleccionadas();
            },
            /**
             * ¿Cabe una butaca más en la selección?
             *
             * El selector es quien decide y avisa al usuario; el mapa solo
             * necesita saberlo para no pintar una butaca que el selector va a
             * rechazar. Sin tope (`null`, cadena vacía o 0) siempre hay cupo.
             */
            hayCupoParaSeleccionar() {
                const max = Number(this.maxSeleccionables);

                if (!Number.isFinite(max) || max <= 0) {
                    return true;
                }

                const seleccionadas = Array.isArray(this.plazasSeleccionadas) ? this.plazasSeleccionadas.length : 0;

                return seleccionadas < max;
            },
            clickRegion: function(plaza_id) {
                if (!this.continuarConCompra && !this.bloquearPasoDos) {
                    let plaza = this.plazas.find(plaza => plaza.id == plaza_id);
    
                    if (plaza && plaza.precios.length > 0 && (plaza.libre || plaza.disponible)) {
                        this.$emit('clickZona', plaza);
                    }                
                }
            },
            registrarSuperficieAsientos() {
                const regionesSvg = this.$el.querySelectorAll('.recinto-zona[data-region]');
                const tieneRegionesMapeadas = Array.from(regionesSvg).some(regionSvg =>
                    this.plazas.some(plaza => String(plaza.id) === String(regionSvg.dataset.region))
                );

                if (tieneRegionesMapeadas) {
                    return;
                }

                const asientosSvg = this.$el.querySelectorAll('[id^="butaca-"]');

                asientosSvg.forEach(asientoSvg => {
                    const svgId = this.getButacaId(asientoSvg);
                    const plaza = this.plazas.find(plazaActual => String(plazaActual.svg_id) === String(svgId));

                    if (!plaza) {
                        return;
                    }

                    // El SVG de butacas no trae anclas `popover-<id>`, así que su popover es el
                    // nativo sobre la propia butaca: el mismo que master pinta en Leaflet.
                    if (Array.isArray(plaza.precios)) {
                        this.drawPopover(asientoSvg, plaza, this.getButacaName(plaza));
                    }

                    const tienePrecios = Array.isArray(plaza.precios) && plaza.precios.length > 0;
                    const disponible = this.checkDisponibilidad(plaza);

                    if (!tienePrecios || !disponible) {
                        asientoSvg.style.cursor = 'not-allowed';
                        asientoSvg.setAttribute('fill', this.noDisponibleColor);
                        return;
                    }

                    // El mismo tipo de bloqueo permitido que contempla Leaflet: una
                    // butaca bloqueada pero sin reserva/venta puede seleccionarse en taquilla.
                    if (!plaza.libre && !plaza.disponible) {
                        plaza.libre = true;
                        plaza.disponible = true;
                    }

                    asientoSvg.style.cursor = 'pointer';
                    asientoSvg.style.transition = 'fill 0.2s';
                    asientoSvg.setAttribute('fill', this.originalColor);
                    asientoSvg.addEventListener('click', () => this.clickRegion(plaza.id));
                });

                this.sincronizarMarcasSeleccionadas();
            },
            registrarSuperficieRegiones(svgElement) {
                if (!this.tipoSvgDiscrepante || svgElement.querySelector('[id^="butaca-"]')) {
                    return;
                }

                const regionesSvg = svgElement.querySelectorAll('.recinto-zona[data-region]');

                regionesSvg.forEach(regionSvg => {
                    const plazaId = regionSvg.dataset.region;
                    const plaza = this.plazas.find(plazaActual => String(plazaActual.id) === String(plazaId));

                    if (!plaza) {
                        return;
                    }

                    const disponible = this.checkDisponibilidad(plaza);
                    const tienePrecios = Array.isArray(plaza.precios) && plaza.precios.length > 0;

                    if (!tienePrecios) {
                        regionSvg.classList.add('no-disponible');
                        return;
                    }

                    if (!disponible) {
                        regionSvg.classList.add('plaza_ocupada');
                        return;
                    }

                    // El mismo bloqueo que ya admite la ruta de butacas y los círculos de
                    // Leaflet: la plaza está bloqueada pero sin reserva ni venta, así que
                    // se puede vender en taquilla. Se actualizan las flags antes de
                    // registrar el clic para que `clickRegion` no la rechace después.
                    if (!plaza.libre && !plaza.disponible) {
                        plaza.libre = true;
                        plaza.disponible = true;
                    }

                    regionSvg.classList.add('plaza_disponible');
                    regionSvg.style.cursor = 'pointer';
                    regionSvg.addEventListener('click', () => this.clickRegion(plaza.id));
                });
            },
            clearButacas() {
                if (this.bloquearPasoDos) {
                    return;
                }

                for (var plaza in this.plazas) {
                    if(this.plazas[plaza].seleccionada) {
                        const butaca = document.querySelector(`[id^="butaca-${this.plazas[plaza].svg_id}-"]`);
                        if (butaca) {
                            butaca.setAttribute('fill', this.originalColor);
                            butaca.setAttribute('seleccionado', 'false');
                            delete this.plazas[plaza].seleccionada;
                        }

                        this.$emit('clearButacas');
                    }
                }
            },
            selectButacas() {
                if (this.bloquearPasoDos) {
                    return;
                }

                var count = this.n_butacas <= 100 ? this.n_butacas : 100;

                for (var plaza in this.plazas) {
                    if (!this.hayCupoParaSeleccionar()) {
                        break;
                    }

                    if(!this.plazas[plaza].seleccionada && this.plazas[plaza].precios.length > 0 && (this.plazas[plaza].libre || this.plazas[plaza].disponible) && count > 0) {
                        this.clickRegion(this.plazas[plaza].id);
                        count--;

                        const butaca = document.querySelector(`[id^="butaca-${this.plazas[plaza].svg_id}-"]`);
                        if (butaca) {
                            butaca.setAttribute('fill', this.seleccionadaColor);
                            butaca.setAttribute('seleccionado', 'true');
                        }
                    }
                }
            },
            selectAllButacas() {
                if (this.bloquearPasoDos) {
                    return;
                }

                var count = 0;

                for (var plaza in this.plazas) {
                    if (!this.hayCupoParaSeleccionar()) {
                        break;
                    }

                    if(this.plazas[plaza].precios.length > 0 && (this.plazas[plaza].libre || this.plazas[plaza].disponible) && count < 100) {
                        this.clickRegion(this.plazas[plaza].id);

                        const butaca = document.querySelector(`[id^="butaca-${this.plazas[plaza].svg_id}-"]`);
                        if (butaca) {
                            butaca.setAttribute('fill', this.seleccionadaColor);
                            butaca.setAttribute('seleccionado', 'true');
                        }

                        count++;
                    }
                }
            },
            /**
             * Ancla `popover-<id>` que el popover de regiones usa como `target`. Se busca en lo
             * que este componente ha pintado (SVG de Leaflet o de Panzoom) y nunca en todo el
             * documento, para no engancharse al ancla de otro componente.
             */
            elementoAnclaPopover(plazaId) {
                const selector = `[id="popover-${plazaId}"]`;
                const anclaEnLeaflet = this.svgRendered && this.svgRendered.querySelector(selector);

                return anclaEnLeaflet || (this.$el && this.$el.querySelector(selector)) || null;
            },
            actualizarPlazasConPopover() {
                if (!Array.isArray(this.plazas)) {
                    this.plazasConPopover = [];
                    return;
                }

                this.plazasConPopover = this.plazas.filter(plaza => plaza && this.elementoAnclaPopover(plaza.id));
            },
            sincronizarMarcasSeleccionadas(idsSeleccionados = this.plazasSeleccionadasIds) {
                if (!Array.isArray(idsSeleccionados) || !Array.isArray(this.plazas)) {
                    return;
                }

                this.plazas.forEach(plaza => {
                    const seleccionada = idsSeleccionados.some(id => String(id) === String(plaza.id));

                    // Planos SVG (tipo_svg 1): la marca es la clase `seleccionada` del
                    // elemento que sirve de ancla al popover de la región.
                    const region = document.getElementById('popover-' + plaza.id) ||
                        (this.svgRendered && this.svgRendered.querySelector(`.recinto-zona[data-region="${plaza.id}"]`));
                    if (region) {
                        region.classList.toggle('seleccionada', seleccionada);
                    }

                    // Planos leaflet: el backend entrega círculos `butaca-<svg_id>-`.
                    if (!plaza.svg_id) {
                        return;
                    }

                    const circulo = (this.svgRendered && this.svgRendered.querySelector(`[id^="butaca-${plaza.svg_id}-"]`)) ||
                        this.$el.querySelector(`[id^="butaca-${plaza.svg_id}-"]`);
                    if (!circulo) {
                        return;
                    }

                    circulo.setAttribute('seleccionado', seleccionada ? 'true' : 'false');

                    if (seleccionada) {
                        circulo.setAttribute('fill', this.seleccionadaColor);
                    } else if (plaza.etiqueta_bloqueo) {
                        circulo.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                    } else if (plaza.precios.length > 0 && (plaza.libre || plaza.disponible)) {
                        circulo.setAttribute('fill', this.originalColor);
                    }
                });
            },
            renderLeafletSvg(svg) {
                const plazasFiltered = this.plazas.filter(plaza => plaza.svg_id);

                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = svg;
            
                const svgElement = tempDiv.firstElementChild;
                const butacas = svgElement.querySelectorAll('[id^="butaca"]');
            
                butacas.forEach(circle => {
                    circle.setAttribute('seleccionado', 'false');
                    const svg_id = this.getButacaId(circle);
                    const plaza = plazasFiltered.find(plaza => plaza.svg_id == svg_id);
                
                    if (plaza) {
                        const title = this.getButacaName(plaza);
                    
                        if (plaza.precios.length === 0) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.noDisponibleColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if ((plaza.libre || plaza.disponible) && plaza.precios.length > 0) {
                            this.drawPopover(circle, plaza, title); 
                
                            circle.style.cursor = 'pointer';
                            circle.style.transition = 'fill 0.2s';
                            circle.setAttribute('fill', this.originalColor);

                            circle.addEventListener('click', () => {
                                let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));

                                setTimeout(() => {
                                    if (!this.isPanning && !this.continuarConCompra && !this.bloquearPasoDos) {
                                        if (!isSeleccionado) {
                                            // Sin cupo no se pinta: el selector rechaza
                                            // la butaca con su aviso y el mapa no puede
                                            // dejarla marcada como si estuviera elegida.
                                            if (this.hayCupoParaSeleccionar()) {
                                                circle.setAttribute('fill', this.seleccionadaColor);
                                                circle.setAttribute('seleccionado', 'true');
                                            }
                                        } else {
                                            if (plaza.etiqueta_bloqueo) {
                                                circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                            } else {
                                                circle.setAttribute('fill', this.originalColor);
                                            }
                                            circle.setAttribute('seleccionado', 'false');
                                        }
                                        this.clickRegion(plaza.id);
                                    }
                                }, 150);
                            });
                        } else if (plaza.ocupada && plaza.ocupada.bloqueada) {
                            if (plaza.ocupada.reserva_id) {
                                circle.setAttribute('ocupada', 'true');
                                circle.style.cursor = 'not-allowed';
                                circle.setAttribute('fill', this.bloqueadaEventosColor);
                                this.drawPopover(circle, plaza, title); 
                            } else {
                                this.drawPopover(circle, plaza, title);    
                                circle.setAttribute('fill', this.bloqueadaEventosColor);
                            }

                            if (plaza.etiqueta_bloqueo) {
                                circle.setAttribute('ocupada', 'true');
                                circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                this.drawPopover(circle, plaza, title); 
                            }

                            if (plaza.info_ocupada && plaza.info_ocupada.concepto) {
                                let content = `<div><strong>Concepto: </strong>${plaza.info_ocupada.concepto}</div>`
                                this.drawPopover(circle, plaza, title, content); 
                            }

                            if (!plaza.ocupada.reserva_id) {
                                if (this.checkDisponibilidad(plaza)) {
                                    plaza.libre = true;
                                    plaza.disponible = true;
                                }
                                circle.addEventListener('click', () => {
                                    let isSeleccionado = JSON.parse(circle.getAttribute('seleccionado'));
    
                                    setTimeout(() => {
                                        if (!this.isPanning && !this.continuarConCompra && !this.bloquearPasoDos) {
                                            if (!isSeleccionado) {
                                                if (this.hayCupoParaSeleccionar()) {
                                                    circle.setAttribute('fill', this.seleccionadaColor);
                                                    circle.setAttribute('seleccionado', 'true');
                                                }
                                            } else {
                                                if (plaza.etiqueta_bloqueo) {
                                                    circle.setAttribute('fill', plaza.etiqueta_bloqueo.color);
                                                } else {
                                                    circle.setAttribute('fill', this.bloqueadaEventosColor);
                                                }
                                                circle.setAttribute('seleccionado', 'false');
                                            }
                                            this.clickRegion(plaza.id);
                                        }
                                    }, 150);
                                }); 
                            }
                        } else if (plaza.ocupada && plaza.ocupada.sesion) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.enSesionEventosColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.en_sesion_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.style.cursor = 'not-allowed';
                            circle.setAttribute('fill', this.enSesionAbonosColor);
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.venta) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaEventosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.comprada_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.vendidaAbonosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        } else if (plaza.ocupada && plaza.ocupada.bloqueada_abonos) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.bloqueadaAbonosColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title); 
                        }

                        if(plaza.info_ocupada && plaza.info_ocupada.numero_pedido){
                            circle.addEventListener('click', () => {
                                let url = `/admin/eventos/${this.$route.params.evento_id}/sesiones/${this.$route.params.sesion_id}/ventas?n_pedido=${plaza.info_ocupada.numero_pedido}`;
                                window.open(url, '_blank');
                            });
                        }

                        if (plaza.info_acceso?.accedido) {
                            circle.setAttribute('ocupada', 'true');
                            circle.setAttribute('fill', this.validadaColor);
                            circle.style.cursor = 'not-allowed';
                            this.drawPopover(circle, plaza, title);
                        }
                    }
                });

                this.registrarSuperficieRegiones(tempDiv.firstElementChild);
                this.svgRendered = tempDiv.firstElementChild;
                this.sincronizarMarcasSeleccionadas();
                this.actualizarPlazasConPopover();

                // Espera al repintado de Leaflet antes de retirar el loader exterior.
                this.$nextTick(() => {
                    setTimeout(() => this.finalizarCargaSvg(), 0);
                });
            },
            drawPopover(circle, plaza, title = null, content = '') {
                if (plaza.precios.length === 0) {
                    content += `<div><strong>No disponible</strong></div>`;
                } else if ((plaza.disponible || plaza.libre) && plaza.precios.length > 0) {
                    content += `<div><strong>Disponible</strong></div>`;
                    content += `Desde: ${this.$n(this.getPrecioPlaza(plaza), "currency")}`;
                }

                if (plaza.ocupada) {
                    if (plaza.etiqueta_bloqueo) {
                        content += `<div><strong>` + plaza.etiqueta_bloqueo.name + `</strong></div>`;
                    }
                    if (plaza.ocupada.reserva_id) {
                        content += `<div><strong>Reservada</strong></div>`;
                    } else if (plaza.ocupada.bloqueada) {
                        content += `<div><strong>Plaza bloqueada</strong></div>`;
                    } else if (plaza.ocupada.bloqueada_abonos) {
                        content += `<div><strong>Plaza bloqueada en abonos</strong></div>`;
                    }
                    if (plaza.ocupada.venta) {
                        content += `<div><strong>Vendida</strong></div>`;
                        if (plaza.info_ocupada) {
                            if (plaza.info_ocupada.numero_pedido) {
                                content += '<div><strong>Nº del pedido: </strong>' + plaza.info_ocupada.numero_pedido + '</div>';
                            }
                            if (plaza.info_ocupada.nombre_venta && plaza.info_ocupada.apellidos_venta) {
                                content += `<div><strong>Nombre: </strong>${plaza.info_ocupada.nombre_venta + ' ' + plaza.info_ocupada.apellidos_venta}</div>`;
                            }
                            if (plaza.info_ocupada.numero_abonado && !plaza.ocupada.renovado) {
                                content += `<div><strong>Abonado no renovado</strong></div>`;
                            }
                        }
                    }
                    if (plaza.ocupada.comprada_abonos) {
                        content += `<div><strong>Vendida en abonos</strong></div>`;
                    }
                    if (plaza.ocupada.sesion) {
                        content += `<div><strong>En sesión</strong></div>`;
                    }
                    if (plaza.ocupada.en_sesion_abonos) {
                        content += `<div><strong>En sesión en abonos</strong></div>`;
                    }
                }

                if (plaza.info_acceso?.accedido) {
                    content += `<div><strong>Hora de acceso: </strong>` + plaza.info_acceso.hora_acceso + `</div>`;
                }

                if (this.load_panzoom) {
                    const popoverOptions = {
                        title: title,
                        content: content,
                        trigger: 'hover',
                        html: true
                    }
    
                    new Popover(circle, popoverOptions);                
                }
            },
            getButacaId(circle) {
                const id = circle.id;
                const idParts = id.split("-");

                return idParts[1];
            },
            getButacaName(plaza) {
                const nButaca = plaza.butaca;
                const nFila = plaza.fila;
                const sector = plaza.sector_name;
                const visibilidad_reducida = plaza.visibilidad_reducida;
                const porcentaje_visibilidad = plaza.porcentaje_visibilidad;
                let name = '';

                if (sector) {
                    name += `Sector: ${sector} - `;
                }

                if (!nButaca && !nFila) {
                    name += `Plaza: ${plaza.numero}`;
                } else {
                    name += `Fila: ${nFila} - Butaca: ${nButaca}`;
                }

                if (visibilidad_reducida) {
                    name += '<span class="text-danger"> Visibilidad Reducida</span>';
                }

                if (porcentaje_visibilidad) {
                    name += `<span class="text-danger">: ${porcentaje_visibilidad} %</span>`;
                }

                return name;
            },
            checkDisponibilidad(plaza) {
                var disponible = plaza.libre || plaza.disponible;

                if (!disponible && plaza.ocupada) {
                    if (plaza.ocupada.bloqueada && (plaza.ocupada.reserva_id == null && !plaza.ocupada.venta && !plaza.ocupada.sesion && !plaza.ocupada.evento_venta && !plaza.ocupada.evento_sesion && !plaza.ocupada.renovado && !plaza.ocupada.evento_bloqueo)) {
                        disponible = true;
                    }
                }

                return disponible;
            }
        },
        components : { SvgPanZoom, LeafletComponent, LeyendaColorEventos },
    }
</script>